import { createTelemetryObject, createTelemetry } from '@shared/core/analytics';

export const listingsPanelTelemetry = createTelemetryObject({
  actions: {
    seeAvailabilityClicked: ({ joyPlaceId, hotelName }: { joyPlaceId?: string; hotelName?: string }) => ({
      category: 'accommodations',
      action: 'TravelButtonInteracted',
      extraInfo: {
        name: 'seeAvailabilityClicked',
        joyPlaceId,
        from: 'Accommodations Console',
        hotelName
      }
    }),
    pickedByCoupleToggled: ({ state }: { state: boolean }) => ({
      category: 'accommodations',
      action: 'TravelFilterInteracted',
      extraInfo: {
        name: 'pickedByCoupleToggled',
        state,
        from: 'Accommodations Console'
      }
    }),
    guestRatingFilterChanged: ({ rating, action }: { rating: number; action: 'added' | 'removed' }) => ({
      category: 'accommodations',
      action: 'TravelFilterInteracted',
      extraInfo: {
        name: 'guestRatingFilterChanged',
        rating,
        action,
        from: 'Accommodations Console'
      }
    }),
    starRatingFilterChanged: ({ rating, action }: { rating: number; action: 'added' | 'removed' }) => ({
      category: 'accommodations',
      action: 'TravelFilterInteracted',
      extraInfo: {
        name: 'starRatingFilterChanged',
        rating,
        action,
        from: 'Accommodations Console'
      }
    }),
    facilityFilterChanged: ({ facility, action }: { facility: string; action: 'added' | 'removed' }) => ({
      category: 'accommodations',
      action: 'TravelFilterInteracted',
      extraInfo: {
        name: 'facilityFilterChanged',
        facility,
        action,
        from: 'Accommodations Console'
      }
    }),
    priceRangeFilterChanged: ({ minPrice, maxPrice }: { minPrice: number; maxPrice: number }) => ({
      category: 'accommodations',
      action: 'TravelFilterInteracted',
      extraInfo: {
        name: 'priceRangeFilterChanged',
        minPrice,
        maxPrice,
        from: 'Accommodations Console'
      }
    }),
    allFiltersReset: () => ({
      category: 'accommodations',
      action: 'TravelFilterInteracted',
      extraInfo: {
        name: 'allFiltersReset',
        from: 'Accommodations Console'
      }
    })
  }
});

const { TelemetryProvider, useTelemetry } = createTelemetry(listingsPanelTelemetry, { eventId: '', section: '' });

export { TelemetryProvider, useTelemetry as useListingsPanelTelemetry };
